export const C = {
  bg: "#03060A",
  ink: "#4DFFA6",
  dim: "#1E7A5C",
  hot: "#EAFFF6",
  cyan: "#5FE8FF",
  accent: "#FFB020",
  danger: "#FF4D4D",
  rock: "#8FD9BC",
} as const;

export const FONT = '"JetBrains Mono", ui-monospace, Menlo, Consolas, monospace';

/** Rectangulo redondeado. Se usa para las placas de las etiquetas. */
export function roundRect(
  cx: CanvasRenderingContext2D,
  x: number,
  y: number,
  w: number,
  h: number,
  r: number,
): void {
  cx.beginPath();
  cx.moveTo(x + r, y);
  cx.lineTo(x + w - r, y);
  cx.quadraticCurveTo(x + w, y, x + w, y + r);
  cx.lineTo(x + w, y + h - r);
  cx.quadraticCurveTo(x + w, y + h, x + w - r, y + h);
  cx.lineTo(x + r, y + h);
  cx.quadraticCurveTo(x, y + h, x, y + h - r);
  cx.lineTo(x, y + r);
  cx.quadraticCurveTo(x, y, x + r, y);
  cx.closePath();
}

/**
 * letterSpacing no esta en los tipos de todos los navegadores.
 * Envolverlo evita ensuciar el resto del render con casts.
 */
export function setTracking(cx: CanvasRenderingContext2D, v: string): void {
  (cx as unknown as { letterSpacing: string }).letterSpacing = v;
}
